export const REGIONS_INITIAL_STATE = {
  list: {},
  selectedList: {},
  title: 'Regions',
  hasSubMenu: true,
  allSelected: false,
};
export const DATE_INITIAL_STATE = {
  title: 'Date',
  hasSubMenu: false,
  selectedList: {},
};

// Check is the item is Se
export function toggleThePresence(
  objectToCheck,
  valueToToggle,
  idOfToggleValue
) {
  let copyOfObjectToCheck = { ...objectToCheck };
  let actionPerformed = '';

  if (!copyOfObjectToCheck.hasOwnProperty(valueToToggle)) {
    copyOfObjectToCheck[valueToToggle] = idOfToggleValue;
    actionPerformed = 'ADDED_TO_STACK';
  } else {
    delete copyOfObjectToCheck[valueToToggle];
    actionPerformed = 'REMOVED_FROM_STACK';
  }

  return [copyOfObjectToCheck, actionPerformed, idOfToggleValue];
}

export function listReducer(state, action) {
  switch (action.type) {
    case 'ADD_ALL':
      return {
        ...state,
        list: action.value,
      };
    case 'TOGGLE_CARD':
      const [teamsAfterToggle, actionPerformed, idOfToggleValue] =
        toggleThePresence(state.selectedList, action.value, action.id);
      let stateToReturn = {
        ...state,
        selectedList: teamsAfterToggle,
        allSelected:
          Object.keys(teamsAfterToggle).length ===
          Object.keys(state.list).length,
      };

      if (actionPerformed === 'ADDED_TO_STACK') {
        return {
          ...stateToReturn,
          currentAddedStack: idOfToggleValue,
        };
      } else if (actionPerformed === 'REMOVED_FROM_STACK') {
        return {
          ...stateToReturn,
          currentRemovedStack: idOfToggleValue,
        };
      }
    // eslint-disable-next-line no-fallthrough
    case 'SELECT_ALL_TOGGLE':
      let stateCopy = { ...state };
      if (
        Object.entries(stateCopy.list).length !=
        Object.entries(stateCopy.selectedList).length
      ) {
        for (const [key, value] of Object.entries(stateCopy.list)) {
          if (!stateCopy.selectedList[key]) {
            stateCopy.selectedList[key] = value;
          }
        }

        return {
          ...stateCopy,
          selectedList: stateCopy.selectedList,
          allSelected: true,
        };
      } else {
        return {
          ...state,
          selectedList: {},
          allSelected: false,
        };
      }
    case 'ADD_FILTERED_OPTIONS':
      return {
        ...state,
        allSelected: false,
        selectedList: action.value,
      };
    case 'REMOVE_SELECTED':
      return {
        ...state,
        selectedList: {},
        allSelected: false,
      };

    default:
      return state;
  }
}

export function hasSelected(array) {
  console.log(array);
  let hasSelected = false;
  for (let list of array) {
    if (Object.keys(list.selectedList).length != 0) {
      hasSelected = true;
      break;
    }
  }

  return hasSelected;
}
